<template>
  <BeerFileUploader
    type="image"
    :bs="{
      display: 'flex',
      flexWrap: 'wrap',
      ...bs,
    }"
    :model-value="modelValue"
    :validate-params="{
      ratio: ratio,
      widthRange: widthRange,
      heightRange: heightRange,
    }"
    :max-files="maxFiles"
    :readonly="readonly"
    :disabled="disabled"
    v-bind="$attrs"
  >

    <template #default="{ rootProps }">
      <slot v-bind="{ rootProps }">
        <NewImage
          :bs="{
            mr: 12,
            ...newImageBs,
          }"
          v-bind="rootProps"
          :disabled="disabled"
        />
      </slot>
    </template>
    <template #items="{ list, handleRemove }">
      <slot
        name="items"
        v-bind="{
          list,
          handleRemove,
          preview: (index) => preview(list, index)
        }"
      >
        <ImageBox
          v-for="(fileItem, index) of list"
          :key="fileItem.id"
          :filename="fileItem.filename"
          :error="fileItem.error"
          :readonly="readonly"
          :item="fileItem"
          :handle-remove="() => handleRemove(fileItem)"
          @click.stop="() => preview(list, index)"
        />
      </slot>
    </template>
  </BeerFileUploader>
</template>
<script lang="tsx">
  import {
    defineComponent, PropType,
  } from 'vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'

  import { BeerFileUploader } from '@xhs/yam-beer/cmp/dataEntry/FileUpload'
  import { BeerBaseFileItem, NumberRange } from '../FileUpload/utils'
  import { viewImgs } from '../../overlayers/Viewer/Viewer'

  import NewImage from './NewImage.vue'
  import ImageBox from './ImageBox.vue'

  import initStyle from './style'

  initStyle()

  /**
   * 上传图片的通用组件
   */
  export default defineComponent({
    name: 'BeerImageUploader',
    components: {
      BeerFileUploader,
      NewImage,
      ImageBox,
    },
    props: {
      maxFiles: {
        type: Number as PropType<number>,
        default: 1,
      },
      modelValue: {
        type: Array as PropType<BeerBaseFileItem[]>,
        default: () => [],
      },
      /**
       * 外层容器样式
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      newImageBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 图片、视频文件比例 1:1, 16:9, 3:4
       */
      ratio: {
        type: [Number, Array] as PropType<number | number[]>,
        default: null,
      },
      /**
       * 图片、视频文件宽度范围
       */
      widthRange: {
        type: Array as PropType<NumberRange>,
      },
      /**
       * 图片、视频文件高度范围
       */
      heightRange: {
        type: Array as PropType<NumberRange>,
      },
      disabled: {
        type: Boolean,
      },
      readonly: {
        type: Boolean,
      },
    },
    setup() {
      function preview(list: BeerBaseFileItem[], index: number) {
        const images = list.map(i => i.url) as string[]
        viewImgs(images, { initialViewIndex: index })
      }

      return {
        preview,
      }
    },
  })
</script>
